<router-outlet></router-outlet>

<tvui-dialog [(visible)]="showPopup" [closable]="false">
	@if (popup(); as pu) {
		<p class="u-title-sub u-m-bottom--xxs">{{ pu.name }}</p>
		<p class="u-m-bottom--sm" [innerHTML]="pu.description"></p>

		<div class="flex-row flex-gap--sm flex-row--end">
			<button (click)="hidePopup()" class="c-btn c-btn--blue">Sluiten</button>
		</div>
	}
</tvui-dialog>
